import React from "react";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { color } from "framer-motion";


interface Props {
  onTapCloseModal: () => void;
}

export const NotConvertedModal = ({ onTapCloseModal }: Props) => {
  const {
    setOpenNotLoginModal,
  } = useModalContext();
  return (
      <BasePageModal
        title=""
        handleClose={() => {
          onTapCloseModal();
        }}
        bottomChildren={
          <BaseRoundButton
            buttonText="閉じる"
            onClick={() => onTapCloseModal()}
          />
        }
      >
        <>
          <p>データ移行がまだ完了していません。</p>
          <p>今までご利用の「MoneyLink」のデータを引き継ぐ場合は、今までご利用の「MoneyLink」を起動してください。</p>
          <p>表示されるメッセージより「Web版を利用する」ボタンをクリックし、Web版へデータを引き継いでください。</p>
          <p>※データ引き継ぎが不要な場合は
          <a onClick={() => setOpenNotLoginModal("ConfirmNotConvert")} style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}>
            こちら
          </a>
          から続行してください。
          </p>
        </>
      </BasePageModal>
  );
};
